$(".mobile-menu-trigger").click(function () {
	$(this).toggleClass("open");
	$(".site-navigation .navigation").toggleClass("open");
});
